<template>
  <div v-if="list.length">
    <div class="text-h6 text--text pa-2">
      {{ translatedTitle }}
    </div>
    <v-list>
      <v-list-item
        v-for="(item, index) in list"
        :key="index"
        @click="handleClickItem(item)"
      >
        <v-list-item-content class="py-2">
          <div class="text-body-1 text--text text-break">
            {{
              item.isWorkplace
                ? transDynamic(item.workplace?.spec, `name,${currentLanguageIso},${needTranslate}`)
                : transDynamic(item.service, `name,${currentLanguageIso},${needTranslate}`)
            }}
          </div>
          <div class="text-body-2 text-secondary--text">
            <span
              v-if="item.isWorkplace && getPriceList(item.workplace).priceClub && filterType === 'clinic'"
              class="text-error--text mr-1"
            >{{ getFormattedPrice(getPriceList(item.workplace).priceClub) }}</span>
            <span
              v-if="item.isWorkplace"
              :class="{
                'text-decoration-line-through': getPriceList(item.workplace).priceClub && filterType === 'clinic',
                'text-success--text':
                  item.workplace?.tab_is_free_with_treatment
                  && filterType === 'clinic',
              }"
            >{{ formattedPrice(item) }}</span>
            <span v-else>{{ item.price }}</span>
            <template v-if="item.agesText && item.isWorkplace">
              <span class="bg-gray-80--text mx-1">•</span>
              {{ item.agesText }}
            </template>
          </div>
        </v-list-item-content>
        <v-list-item-icon class="align-self-auto">
          <v-icon>
            ui-icon-arrow-right
          </v-icon>
        </v-list-item-icon>
      </v-list-item>
    </v-list>
  </div>
</template>

<script setup lang="ts">
import I18NextVue from 'i18next'
import { storeToRefs } from 'pinia'
import { getFormattedPrice } from 'www/utils'
import transDynamic from 'djanjucks/filters/transDynamic'
import { useDoctorPageLpuListStore } from 'www/vue_components/common/DoctorPageLpuList/stores'
import type { SelectWorkplaceOrServiceItem } from 'www/vue_components/common/DoctorPageLpuList/types'
import { getPriceList } from 'www/vue_components/common/DoctorPageLpuList/functions'

const props = defineProps<{
  title: string
  list: SelectWorkplaceOrServiceItem[]
  isLpuAppointmentTypeChosen: boolean
  lpuId: number
}>()

const { t, language } = I18NextVue
const options = { ns: language }

const translatedTitle = t(props.title, options)
const emit = defineEmits(['click-item'])

const doctorPageLpuListStore = useDoctorPageLpuListStore()
const { filterType } = storeToRefs(doctorPageLpuListStore)

const currentLanguageIso = window.LANGUAGE_DATA.currentLanguage.iso
const needTranslate = true

function handleClickItem(item: SelectWorkplaceOrServiceItem) {
  emit('click-item', item)
}

function formattedPrice(item: SelectWorkplaceOrServiceItem) {
  if (
    item.workplace?.tab_is_free_with_treatment
    && filterType.value === 'clinic'
  ) {
    return t('Бесплатно', options)
  }

  const priceList = getPriceList(item.workplace)

  switch (filterType.value) {
    case 'clinic': {
      const { price } = priceList

      return typeof price === 'number' ? getFormattedPrice(price) : null
    }
    case 'home': {
      const { priceHome } = priceList

      return typeof priceHome === 'number' ? getFormattedPrice(priceHome) : null
    }
    case 'telemed': {
      const { priceOnline, priceMedtochkaTelemed } = priceList

      if (typeof priceOnline === 'number') {
        return getFormattedPrice(priceOnline)
      }

      if (typeof priceMedtochkaTelemed === 'number') {
        return getFormattedPrice(priceMedtochkaTelemed)
      }

      return null
    }
  }
}
</script>
